<template>
  <div>
    <div class="title">Reference sequences</div>
    <!--标签-->
    <div class="tag">
      <div class="tagc">
        <ul>
          <li><div class="one"></div></li>
          <li>Upstream2k</li>
          <li><div class="two"></div></li>
          <li>5′UTR</li>
          <li><div class="three"></div></li>
          <li>CDS</li>
          <li><div class="four"></div></li>
          <li>3′UTR</li>
          <li><div class="five"></div></li>
          <li>Downstream2k</li>
        </ul>
      </div>
    </div>
    <!--第一块-->
    <div class="container">
      <div class="left">
        <h3>Genomic sequence</h3>
        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copySequencesData"
            v-clipboard:success="copySequences"
            v-clipboard:error="onError"
          >
            Copy sequences
          </el-button></span
        >

        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copyUpstream2kData"
            v-clipboard:success="copyUpstream2k"
            v-clipboard:error="onError"
          >
            Copy Upstream2k
          </el-button></span
        >
        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copygDNAData"
            v-clipboard:success="copygDNA"
            v-clipboard:error="onError"
          >
            Copy gDNA
          </el-button></span
        >
        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copyCDSData"
            v-clipboard:success="copyCDS"
            v-clipboard:error="onError"
          >
            Copy CDS
          </el-button></span
        >
        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copyDownstream2kData"
            v-clipboard:success="copyDownstream2k"
            v-clipboard:error="onError"
          >
            Copy Downstream2k
          </el-button></span
        >
      </div>
      <div class="right">
        <!-- <el-input type="textarea" v-model="str" :rows="15"></el-input> -->
        <p ref="listcont">
          <span
            :ref="item.type"
            v-for="(item, index) in structureList"
            :key="index"
            :style="{ background: item.bgcolor, color: item.color }"
            >{{ item.sequence }}</span
          >
        </p>
      </div>
    </div>
    <!--第二块-->
    <div class="container">
      <div class="left2">
        <h3 class="twoh3">Protein sequence</h3>
        <span
          ><el-button
            class="btn"
            v-clipboard:copy="copyProteinData"
            v-clipboard:success="copyProtein"
            v-clipboard:error="onError"
          >
            Copy sequences
          </el-button></span
        >
      </div>
      <div class="right1">
        <p class="mgtop">
          <span ref="Protein">{{ copyProteinData }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Species from "../Species.vue";
export default {
  components: { Species },
  data() {
    return {
      tabData: "",
      sequenceOne: "",
      sequenceTwo: "",
      structureList: "",
      copySequencesData: "",
      copyUpstream2kData: "",
      copygDNAData: "",
      copyCDSData: "",
      copyDownstream2kData: "",
      copyProteinData: "",
    };
  },
  props: ["id"],
  created() {
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    //console.log(this.id);
    this.getSequences(this.id);
  },
  methods: {
    copyProtein() {
      let structureList = this.structureList;
      for (let i = 0; i < structureList.length; i++) {
        if (structureList[i].type == "upstream2k") {
          structureList[i].bgcolor = "#abbac3";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR5") {
          structureList[i].bgcolor = "#f87481";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "CDS") {
          structureList[i].bgcolor = "#09b";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR3") {
          structureList[i].bgcolor = "#ffb902";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "downstream2k") {
          // structureList[i].bgcolor = "#5c8ce6 !important";
          // structureList[i].color = "#fff !important";
          structureList[i].bgcolor = "#61daa5";
          structureList[i].color = "#fff";
        } else {
          structureList[i].bgcolor = "none";
          structureList[i].color = "#000";
        }
      }
      this.structureList = structureList;
      this.$refs.Protein.style.background = "#5c8ce6";
      this.$refs.Protein.style.color = "#fff";
    },
    copyDownstream2k(e) {
      let structureList = this.structureList;
      for (let i = 0; i < structureList.length; i++) {
        if (structureList[i].type == "upstream2k") {
          structureList[i].bgcolor = "#abbac3";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR5") {
          structureList[i].bgcolor = "#f87481";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "CDS") {
          structureList[i].bgcolor = "#09b";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR3") {
          structureList[i].bgcolor = "#ffb902";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "downstream2k") {
          structureList[i].bgcolor = "#5c8ce6 !important";
          structureList[i].color = "#fff !important";
        } else {
          structureList[i].bgcolor = "none";
          structureList[i].color = "#000";
        }
      }
      this.structureList = structureList;
    },
    copyCDS(e) {
      let structureList = this.structureList;
      for (let i = 0; i < structureList.length; i++) {
        if (structureList[i].type == "upstream2k") {
          structureList[i].bgcolor = "#abbac3";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR5") {
          structureList[i].bgcolor = "#f87481";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "CDS") {
          structureList[i].bgcolor = "#5c8ce6 !important";
          structureList[i].color = "#fff !important";
        } else if (structureList[i].type == "UTR3") {
          structureList[i].bgcolor = "#ffb902";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "downstream2k") {
          structureList[i].bgcolor = "#61daa5";
          structureList[i].color = "#fff";
        } else {
          structureList[i].bgcolor = "none";
          structureList[i].color = "#000";
        }
      }
      this.structureList = structureList;
    },
    copygDNA(e) {
      let structureList = this.structureList;
      // let index1 = structureList.findIndex(function (value, index, arr) {
      //   return value.type == "UTR5";
      // });
      // let index2 = structureList.findIndex(function (value, index, arr) {
      //   return value.type == "UTR3";
      // });
      ////console.log(index1, index2);
      for (let i = 0; i < structureList.length; i++) {
        if (i >= 1 && i < (structureList.length-1)) {
          structureList[i].bgcolor = "#5c8ce6 !important";
          structureList[i].color = "#fff !important";
        } else {
          if (structureList[i].type == "upstream2k") {
            structureList[i].bgcolor = "#abbac3";
            structureList[i].color = "#fff";
          } else if (structureList[i].type == "UTR5") {
            structureList[i].bgcolor = "#f87481";
            structureList[i].color = "#fff";
          } else if (structureList[i].type == "CDS") {
            structureList[i].bgcolor = "#09b";
            structureList[i].color = "#fff";
          } else if (structureList[i].type == "UTR3") {
            structureList[i].bgcolor = "#ffb902";
            structureList[i].color = "#fff";
          } else if (structureList[i].type == "downstream2k") {
            structureList[i].bgcolor = "#61daa5";
            structureList[i].color = "#fff";
          } else {
            structureList[i].bgcolor = "none";
            structureList[i].color = "#000";
          }
        }
      }
      this.structureList = structureList;
    },
    copyUpstream2k(e) {
      let structureList = this.structureList;
      for (let i = 0; i < structureList.length; i++) {
        if (structureList[i].type == "upstream2k") {
          structureList[i].bgcolor = "#5c8ce6 !important";
          structureList[i].color = "#fff !important";
        } else if (structureList[i].type == "UTR5") {
          structureList[i].bgcolor = "#f87481";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "CDS") {
          structureList[i].bgcolor = "#09b";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "UTR3") {
          structureList[i].bgcolor = "#ffb902";
          structureList[i].color = "#fff";
        } else if (structureList[i].type == "downstream2k") {
          structureList[i].bgcolor = "#61daa5";
          structureList[i].color = "#fff";
        } else {
          structureList[i].bgcolor = "none";
          structureList[i].color = "#000";
        }
      }
      this.structureList = structureList;
      //alert("复制成功： " + e.text);
    },
    copySequences(e) {
      let structureList = this.structureList;
      for (let i = 0; i < structureList.length; i++) {
        structureList[i].bgcolor = "#5c8ce6 !important";
        structureList[i].color = "#fff !important";
      }
      this.structureList = structureList;
      //alert("复制成功： " + e.text);
    },
    onError(e) {
      //alert('复制失败',e)
    },
    getSequences(id) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
         .get("/bena/server/gooal/gene/sequence/" + id,{
          headers: { Authorization: token },
        })
        // .post("/api/server-api/detail/sequence", {
        //   geneId: "evm.TU.original_scaffold_2444.11",
        //   version: "D_oleifera",
        // })
        .then(function (response) {
          //console.log(response);
          let structureList = response.data.structureList;
          let copySequences = "";
          let copyUpstream2kData = "";
          let copygDNAData = "";
          let copyCDSData = "";
          let copyDownstream2kData = "";
          let copyProteinData = "";
          let sequenceList = response.data.sequenceList;
          for (let i = 0; i < sequenceList.length; i++) {
            if (sequenceList[i].type == "protein") {
              copyProteinData += sequenceList[i].sequence;
            }
          }
          that.copyProteinData = copyProteinData;
          for (let i = 0; i < structureList.length; i++) {
            for (let x in structureList[i]) {
              copySequences += structureList[i][x];
              structureList[i].sequence = structureList[i][x];
              structureList[i].type = x;
              if (x == "upstream2k") {
                structureList[i].bgcolor = "#abbac3";
                structureList[i].color = "#fff";
                copyUpstream2kData += structureList[i][x];
              } else if (x == "UTR5") {
                structureList[i].bgcolor = "#f87481";
                structureList[i].color = "#fff";
              } else if (x == "CDS") {
                structureList[i].bgcolor = "#09b";
                structureList[i].color = "#fff";
                copyCDSData += structureList[i].sequence;
              } else if (x == "UTR3") {
                structureList[i].bgcolor = "#ffb902";
                structureList[i].color = "#fff";
              } else if (x == "downstream2k") {
                structureList[i].bgcolor = "#61daa5";
                structureList[i].color = "#fff";
                copyDownstream2kData += structureList[i].sequence;
              } else {
                structureList[i].bgcolor = "none";
                structureList[i].color = "#000";
              }
            }
          }
          // let index1 = structureList.findIndex(function (value, index, arr) {
          //   return value.type == "UTR5";
          // });
          // let index2 = structureList.findIndex(function (value, index, arr) {
          //   return value.type == "UTR3";
          // });
          for (let i = 0; i < structureList.length; i++) {
            if (i >= 1 && i <= (structureList.length-1)) {
              copygDNAData += structureList[i].sequence;
            }
          }
          that.copyDownstream2kData = copyDownstream2kData;
          that.copyCDSData = copyCDSData;
          that.copygDNAData = copygDNAData;
          that.copyUpstream2kData = copyUpstream2kData;
          that.copySequencesData = copySequences;
          that.structureList = structureList;
          //console.log(structureList);
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.title {
  color: seagreen;
}
.tag {
  margin-left: 420px;
  margin-bottom: 20px;
  width: 490px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  background-color: #ffffff;
}
.tagc {
  margin-left: -50px;
}
.tagc li {
  float: left;
  list-style: none;
  margin-left: 20px;
}
.one {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #abbac3;
}
.two {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #f87481;
}
.three {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #09b;
}
.four {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #ffb902;
}
.five {
  width: 15px;
  height: 15px;
  margin: 12px -20px 0 0;
  border-radius: 50%;
  background-color: #61daa5;
}
.container {
  display: flex;
  overflow: hidden;
}
.container h3 {
  color: seagreen;
}
.left {
  float: left;
  width: 200px;
  height: 322px;
  text-align: center;
  background-color: #fff;
  border-top: #ccc 1px solid;
  border-left: #ccc 1px solid;
}
.left2 {
  float: left;
  width: 200px;
  height: 322px;
  text-align: center;
  background-color: #fff;
  border-top: #ccc 1px solid;
  border-bottom: #ccc 1px solid;
  border-left: #ccc 1px solid;
  border-right: #ccc 1px solid;
}
.right {
  float: right;
  margin-left: -1px;
  width: 708px;
  height: 320px;
  background-color: #fff;
  border: solid 1px #ccc;
  overflow: auto;
  padding: 0 10px 10px 10px;
  color: #aaa;
  font-size: 13px;
}
.right1 {
  float: right;
  margin-left: -1px;
  width: 708px;
  height: 312px;
  background-color: #fff;
  border: solid 1px #ccc;
  overflow: auto;
  padding: 0 10px 10px 10px;
  color: #aaa;
  font-size: 13px;
}
.right1 .mgtop {
  margin-top: 50px;
}

.right p {
  word-break: break-all;
  margin: 0;
  padding: 0;
}
.right1 p {
  word-break: break-all;
  margin: 0;
  padding: 0;
}
.twoh3 {
  margin-top: 100px;
}
.btn {
  margin-bottom: 10px;
  width: 160px;
  background-color: seagreen;
  color: #fff;
}
.el-button {
  width: 160px;
  height: 35px;
  background: seagreen;
  color: #fff;
  line-height: 10px;
  border-radius: 0;
}
</style>>